export function CookieIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <desc>Two cookies on top of each other</desc>
      <path fill="#D87B00" d="M29 6A13 13 0 1 0 29 32A13 13 0 1 0 29 6Z"></path>
      <path
        fill="#FFB300"
        d="M19 16A13 13 0 1 0 19 42A13 13 0 1 0 19 16Z"
      ></path>
      <path
        fill="#683529"
        d="M17.5 26A2.5 2.5 0 1 0 17.5 31 2.5 2.5 0 1 0 17.5 26zM19.5 20A1.5 1.5 0 1 0 19.5 23 1.5 1.5 0 1 0 19.5 20zM23 32A2 2 0 1 0 23 36 2 2 0 1 0 23 32zM11.5 29A1.5 1.5 0 1 0 11.5 32 1.5 1.5 0 1 0 11.5 29zM25.501 25.999A1.5 1.5 0 1 0 25.501 28.999 1.5 1.5 0 1 0 25.501 25.999zM16 35A1 1 0 1 0 16 37 1 1 0 1 0 16 35z"
      ></path>
      <g>
        <path
          fill="#4C2114"
          d="M26 10A2 2 0 1 0 26 14 2 2 0 1 0 26 10zM31.499 14.998999999999999A1.5 1.5 0 1 0 31.499 17.999 1.5 1.5 0 1 0 31.499 14.998999999999999zM32.499 9A1.5 1.5 0 1 0 32.499 12 1.5 1.5 0 1 0 32.499 9zM36 20A1 1 0 1 0 36 22 1 1 0 1 0 36 20z"
        ></path>
      </g>
    </svg>
  )
}

export default CookieIcon
